import DatepickerRange from '../../../../../components/DatePickers/Range';
import Select from '../../../../../components/Select/Custom';
import Dropdown from '../../../../../components/Dropdown/Default';
import RequestSearchSelect from '../../../../../components/Select/RequestSearchSelect';
import VirtualSelect from '../../../../../components/Select/Virtual';

export const getFormFields = (statuses, modes, users, endDate, startDate, getUsersList, methods) => {
  const elements = [
    {
      labelName: 'Date',
      name: 'date',
      id: 'exportDatepickerFrom',
      component: DatepickerRange,
      defStartDate: startDate,
      defEndDate: endDate,
    },
    {
      labelName: 'Users',
      name: 'include_users',
      title: 'Users',
      id: 'users-search',
      onRequestFunc: getUsersList,
      component: RequestSearchSelect,
      data: users,
    },
    {
      labelName: 'Methods',
      name: 'include_methods',
      toggleBtnTitle: 'Methods',
      component: VirtualSelect,
      data: methods,
      showOptionId: false,
      menuWidth: 350,
      selectedOptions: methods.map((item) => item.id),
    },
    {
      labelName: 'Status',
      name: 'include_statuses',
      title: 'Statuses',
      toolbarClassStr: 'export__empty-dropdown',
      id: 'status-dropdown',
      allSelected: true,
      component: Select,
      data: statuses,
    },
    {
      labelName: 'Modes',
      name: 'include_modes',
      id: 'exportModesDropdown',
      simple: true,
      component: Dropdown,
      data: modes,
      buttonId: 'modes-button',
    },
  ];

  return elements.filter(Boolean);
};

export const checkModes = (modes) => {
  const all = {
    id: -1,
    title: 'All',
  };

  const checkAll = modes?.find((item) => item.title.toLowerCase() === 'all');

  let newModes = [];
  if (!checkAll) {
    newModes = [all, ...modes];
    return newModes;
  }

  return modes;
};
